//
import type { AxiosItem } from '@/types/Components/Response'
import type { OptimisationReport } from '@/types/Models/OptimisationReport'
import type { OptimizationReportStoreState } from '@/types/Store'
import { defineStore } from 'pinia'
import { LoadingStatus } from '@/const/LoadingStatus'
import AssignmentProxy from '@/proxies/AssignmentProxy'

const defaultReport: OptimisationReport = {
  manual: [],
  optimization: [],
  manualTotal: '0',
  percentSaved: 0,
  averageSavingsPerPackage: '0',
  info: {
    customer: '',
    reference: '',
    date: '',
    distributionStart: '',
    serviceLevel: '',
    fileName: null,
    workName: '',
    totalAmount: 0,
    customerNumber: '',
    invoiceReference: '',
    shortName: '',
    totalWeight: '',
    distributionChannel: '',
  },
  totalSavings: '0',
  optimizationCost: '0',
  optimizationProductionManagement: 0,
  hidePrice: false,
}

const cloneDefaultReport = () => JSON.parse(JSON.stringify(defaultReport)) as OptimisationReport

export const useOptimizationReportStore = defineStore('optimizationReport', {
  state: (): OptimizationReportStoreState => ({
    status: LoadingStatus.PENDING,
    report: cloneDefaultReport(),
  }),
  actions: {
    reset() {
      this.report = cloneDefaultReport()
      this.status = LoadingStatus.PENDING
    },
    fetch(assignmentId: string) {
      this.status = LoadingStatus.LOADING

      return new AssignmentProxy()
        .getReportData(assignmentId)
        .then((response: AxiosItem<OptimisationReport>) => {
          this.report = { ...cloneDefaultReport(), ...response.data }
          this.status = LoadingStatus.SUCCESS
          return response
        })
        .catch((error) => {
          this.status = LoadingStatus.FAILURE
          throw error
        })
    },
  },
})

export type OptimizationReportStore = ReturnType<typeof useOptimizationReportStore>
